export const SIDE_MODAL_CONSTANTS = {
    overFlowYHidden: 'overflow-y-hidden',
    events: {
        close: {
            name: 'CLOSE_MODAL',
            value: true
        }
    }
};
